import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  transactionsHistory: {
    id: 'transactionsHistory',
    defaultMessage: 'Transactions history',
  },
  transactionsAll: {
    id: 'transactionsAll',
    defaultMessage: 'All accounts',
  },
  balanceDebit: {
    id: 'balanceDebit',
    defaultMessage: 'Debit',
  },
  balanceCredit: {
    id: 'balanceCredit',
    defaultMessage: 'Credit',
  },
  balanceTotal: {
    id: 'balanceTotal',
    defaultMessage: 'Total',
  },
});

export default { ...globalIntl, ...m };
